import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  colors: [],
};

const getters = {
  getColors: (state) => state.colors,
  getcolorById: (state) => (id) => state.colors.find((x) => x.id == id),
  getColorsObject: (state, getters) => {
    const colorsArray = getters.getColors; // your array of colors
    const colorsObj = colorsArray.reduce((acc, color) => {
      acc[color.name] = color.val;
      return acc;
    }, {});
    return { colors: colorsObj };
  },
};

const actions = {
  async fetchColors({ commit }) {
    try {
      const resp = await api.get("/colors");
      if (resp.status == 200) {
        const colors = resp.data.data;
        commit("setColors", colors);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateColor({ commit }, color) {
    try {
      const id = color.id;
      color._method = "patch";

      const resp = await api.post(`/colors/${id}`, color);
      if (resp.status == 200) {
        const color = resp.data.data;
        commit("updateColor", color);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async addColor({ commit }, color) {
    try {
      const resp = await api.post(`/colors`, color);

      if (resp.status == 201) {
        const color = resp.data.data;

        commit("addColor", color);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteColor({ commit }, id) {
    try {
      const resp = await api.delete(`/colors/${id}`);
      if (resp.status == 204) {
        commit("deleteColor", id);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setColors(state, colors) {
    state.colors = colors;
  },
  updateColor(state, color) {
    const id = color.id;
    const index = state.colors.findIndex((color) => color.id == id);
    if (index !== -1) {
      state.colors[index] = color;
    }
  },
  addColor(state, color) {
    state.colors.unshift(color);
  },

  deleteColor(state, id) {
    const index = state.colors.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.colors.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
